export default function TbWC17({data}) {
    let lastReading = data.data;

    return (
        <>
        <div className="card card-table mb-4 rounded-1 shadow-sm">
          <div className="card-header py-2">
            <h4 className="my-0">WC17</h4>
          </div>
          <div className="card-body nopadding">
          <table className="table table-sm my-0 tbl">
              <tbody>
                <tr>
                  <th scope="col">Level</th>
                  <td>{lastReading.wc17_wc17_level}%</td>
                </tr>
                <tr>
                  <th scope="col">Temp</th>
                  <td>{lastReading.wc17_wc17_temp}</td>
                </tr>
                <tr>
                  <th scope="col">Holding Tube</th>
                  <td>{lastReading.wc17_holdingtube_temp}</td>
                </tr>
                <tr>
                  <th scope="col">HWS Temp</th>
                  <td>{lastReading.wc17_hws_temp}</td>
                </tr>
                <tr>
                  <th scope="col">In Process</th>
                  <td>{lastReading.wc17_wc17_inproc}</td>
                </tr>
                <tr>
                  <th scope="col">In FF</th>
                  <td>{lastReading.wc17_wc17_inff}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </>
    )
}